export default __webpack_public_path__ + "static/media/correct-answer.e1cf8406.mp3";